export default "__VITE_ASSET__CHpDOCNo__"